export default {
  // Tiêu đề trang
  'luckySpin.ticket.title': 'Cài đặt Vé tham gia',
  'luckySpin.ticket.management': 'Quản lý Vé',

  // Trường biểu mẫu
  'luckySpin.ticket.ticketId': 'ID Vé',
  'luckySpin.ticket.ticketName': 'Tên Vé',
  'luckySpin.ticket.ticketDescription': 'Mô tả',
  'luckySpin.ticket.activityName': 'Hoạt động liên kết',
  'luckySpin.ticket.selectActivity': 'Chọn hoạt động',
  'luckySpin.ticket.validityType': 'Loại hiệu lực',
  'luckySpin.ticket.validitySetting': 'Cài đặt hiệu lực',
  'luckySpin.ticket.validityHours': 'Số giờ hiệu lực sau khi nhận',
  'luckySpin.ticket.validTimeRange': 'Khoảng thời gian hiệu lực',
  'luckySpin.ticket.sort': 'Thứ tự sắp xếp',
  'luckySpin.ticket.status': 'Trạng thái',
  'luckySpin.ticket.remark': 'Ghi chú',
  'luckySpin.ticket.createTime': 'Thời gian tạo',
  'luckySpin.ticket.createUser': 'Người tạo',
  'luckySpin.ticket.updateTime': 'Thời gian cập nhật',
  'luckySpin.ticket.updateUser': 'Người cập nhật',

  // Loại hiệu lực
  'luckySpin.ticket.validity.permanent': 'Vĩnh viễn',
  'luckySpin.ticket.validity.afterReceive': 'Thời gian chỉ định sau khi nhận',
  'luckySpin.ticket.validity.fixedTime': 'Khoảng thời gian cố định',

  // Trạng thái
  'luckySpin.ticket.status.enabled': 'Kích hoạt',
  'luckySpin.ticket.status.disabled': 'Vô hiệu hóa',

  // Nút
  'luckySpin.ticket.button.add': 'Thêm Vé',
  'luckySpin.ticket.button.edit': 'Chỉnh sửa',
  'luckySpin.ticket.button.delete': 'Xóa',
  'luckySpin.ticket.button.detail': 'Chi tiết',
  'luckySpin.ticket.button.search': 'Tìm kiếm',
  'luckySpin.ticket.button.reset': 'Đặt lại',

  // Thông báo
  'luckySpin.ticket.tip.bindRule': 'Mỗi vé chỉ có thể liên kết với một hoạt động, và một hoạt động có thể liên kết với nhiều vé.',
  'luckySpin.ticket.confirm.delete': 'Bạn có chắc chắn muốn xóa vé này không? Thao tác này không thể hoàn tác.',
  'luckySpin.ticket.message.createSuccess': 'Tạo thành công',
  'luckySpin.ticket.message.updateSuccess': 'Cập nhật thành công',
  'luckySpin.ticket.message.deleteSuccess': 'Xóa thành công',
  'luckySpin.ticket.message.operationFailed': 'Thao tác thất bại',
  'luckySpin.ticket.message.cannotDeleteWithUnusedTickets': 'Không thể xóa: còn vé thành viên chưa sử dụng',

  // Xác thực biểu mẫu
  'luckySpin.ticket.validate.ticketNameRequired': 'Vui lòng nhập tên vé',
  'luckySpin.ticket.validate.ticketNameMax': 'Tên vé không được vượt quá 100 ký tự',
  'luckySpin.ticket.validate.activityRequired': 'Vui lòng chọn hoạt động',
  'luckySpin.ticket.validate.validityTypeRequired': 'Vui lòng chọn loại hiệu lực',
  'luckySpin.ticket.validate.validityHoursRequired': 'Vui lòng nhập số giờ hiệu lực',
  'luckySpin.ticket.validate.validityHoursRange': 'Phạm vi số giờ hiệu lực: 1-720',
  'luckySpin.ticket.validate.validTimeRangeRequired': 'Vui lòng chọn khoảng thời gian hiệu lực',
  'luckySpin.ticket.validate.statusRequired': 'Vui lòng chọn trạng thái',
  'luckySpin.ticket.requiredVipLevel': 'Yêu cầu cấp VIP ≥',
  'luckySpin.ticket.validate.requiredVipLevel': 'Vui lòng chọn yêu cầu cấp VIP (tùy chọn)',

  // Giới hạn sử dụng
  'luckySpin.ticket.usageRestrictionType': 'Loại giới hạn sử dụng',
  'luckySpin.ticket.restrictionAmount': 'Số tiền giới hạn',
  'luckySpin.ticket.usageRestriction.none': 'Không giới hạn',
  'luckySpin.ticket.usageRestriction.singleDeposit': 'Số tiền nạp đơn lần',
  'luckySpin.ticket.usageRestriction.cumulativeDeposit': 'Tổng số tiền nạp tích lũy',
  'luckySpin.ticket.usageRestriction.bettingTurnover': 'Doanh thu cược',
  'luckySpin.ticket.usageRestriction.bettingTurnoverTip': 'Tính từ thời điểm nhận vé',
  'luckySpin.ticket.validate.restrictionAmountRequired': 'Vui lòng nhập số tiền giới hạn',
  'luckySpin.ticket.validate.restrictionAmountMin': 'Số tiền phải lớn hơn 0',
  'luckySpin.ticket.placeholder.usageRestrictionType': 'Chọn loại giới hạn sử dụng',
  'luckySpin.ticket.placeholder.restrictionAmount': 'Nhập số tiền',

  // Placeholder
  'luckySpin.ticket.placeholder.ticketName': 'Nhập tên vé',
  'luckySpin.ticket.placeholder.ticketDescription': 'Nhập mô tả',
  'luckySpin.ticket.placeholder.selectActivity': 'Chọn hoạt động',
  'luckySpin.ticket.placeholder.validityType': 'Chọn loại hiệu lực',
  'luckySpin.ticket.placeholder.validityHours': 'Nhập số giờ',
  'luckySpin.ticket.placeholder.startTime': 'Thời gian bắt đầu',
  'luckySpin.ticket.placeholder.endTime': 'Thời gian kết thúc',
  'luckySpin.ticket.placeholder.sort': 'Nhập thứ tự sắp xếp, mặc định 0',
  'luckySpin.ticket.placeholder.status': 'Chọn trạng thái',
  'luckySpin.ticket.placeholder.remark': 'Nhập ghi chú',

  // Tiêu đề modal
  'luckySpin.ticket.modal.addTitle': 'Thêm Vé',
  'luckySpin.ticket.modal.editTitle': 'Chỉnh sửa Vé',
  'luckySpin.ticket.modal.detailTitle': 'Chi tiết Vé',

  // Biểu mẫu toàn trang
  'luckySpin.ticket.form.title.add': 'Thêm Vé tham gia',
  'luckySpin.ticket.form.title.edit': 'Chỉnh sửa Vé tham gia',
  'luckySpin.ticket.form.basicSettings': 'Cài đặt cơ bản',
  'luckySpin.ticket.form.multiLanguageSettings': 'Cài đặt đa ngôn ngữ (Hiển thị bên ngoài)',
  'luckySpin.ticket.form.ticketNameInternal': 'Tên vé (Nội bộ)',
  'luckySpin.ticket.form.ticketNameExternal': 'Tên vé (Hiển thị bên ngoài)',
  'luckySpin.ticket.form.ticketDescriptionInternal': 'Mô tả vé',
  'luckySpin.ticket.form.ticketDescriptionExternal': 'Mô tả vé (Hiển thị bên ngoài)',
  'luckySpin.ticket.form.bindActivity': 'Liên kết hoạt động',
  'luckySpin.ticket.form.selectActivity': 'Vui lòng chọn hoạt động vòng quay',
  'luckySpin.ticket.form.language': 'Ngôn ngữ',
  'luckySpin.ticket.form.selectLanguage': 'Vui lòng chọn ngôn ngữ',
  'luckySpin.ticket.form.save': 'Lưu',
  'luckySpin.ticket.form.back': 'Quay lại',
  'luckySpin.ticket.form.saving': 'Đang lưu...',

  // Mẫu hoạt động Vòng quay May mắn
  'luckySpin.template.title': 'Cài đặt Vòng quay',
  'luckySpin.template.prizeConfig': 'Cấu hình giải thưởng',
  'luckySpin.template.commonParams': 'Tham số chung',

  // Loại giải thưởng
  'luckySpin.template.prizeType': 'Loại giải thưởng',
  'luckySpin.template.prizeType.cash': 'Tiền mặt',
  'luckySpin.template.prizeType.point': 'Điểm',
  'luckySpin.template.prizeType.physical': 'Giải thực',
  'luckySpin.template.prizeType.retry': 'Thử lại',
  'luckySpin.template.prizeType.noPrize': 'Không trúng',

  // Trường giải thưởng
  'luckySpin.template.coinCode': 'Tiền tệ',
  'luckySpin.template.cashAmount': 'Số tiền',
  'luckySpin.template.flowMultiple': 'Bội số vòng cược',
  'luckySpin.template.pointAmount': 'Số điểm',
  'luckySpin.template.prizeTitle': 'Tiêu đề giải thưởng (Nội bộ)',
  'luckySpin.template.prizeConfigButton': 'Cấu hình đa ngôn ngữ',
  'luckySpin.template.prizeConfigured': '✓ Đã cấu hình',
  'luckySpin.template.prizeLimit': 'Giới hạn',
  'luckySpin.template.probability': 'Xác suất (%)',
  'luckySpin.template.operation': 'Thao tác',

  // Tham số chung
  'luckySpin.template.visibleEntry': 'Lối vào hiển thị',
  'luckySpin.template.ticketOnlyVisible': 'Chỉ hiển thị cho người dùng có vé',
  'luckySpin.template.appOnly': 'Chỉ APP',
  'luckySpin.template.drawLimit': 'Giới hạn quay',
  'luckySpin.template.requirePhoneVerified': 'Chỉ người dùng đã xác minh có thể quay',
  'luckySpin.template.cooldownSeconds': 'Thời gian chờ (giây)',

  // Thông báo
  'luckySpin.template.prizesCountHint': 'Vòng quay cố định 8 giải thưởng (8 khu vực)',
  'luckySpin.template.totalProbability': 'Tổng xác suất',
  'luckySpin.template.probabilityError': 'Tổng hiện tại là {value}%, cần điều chỉnh về 100%',
  'luckySpin.template.rules': 'Quy tắc',
  'luckySpin.template.rule0': 'Vòng quay cố định 8 giải thưởng',
  'luckySpin.template.rule1': 'Xác suất hỗ trợ 4 chữ số thập phân',
  'luckySpin.template.rule2': 'Tổng xác suất phải = 100%',
  'luckySpin.template.rule3': 'Giới hạn = -1 nghĩa là không giới hạn',
  'luckySpin.template.rule4': 'Cần ít nhất một giải thưởng',

  // Xác thực
  'luckySpin.template.validate.prizeType': 'Vui lòng chọn loại giải thưởng',
  'luckySpin.template.validate.coinCode': 'Vui lòng chọn tiền tệ',
  'luckySpin.template.validate.cashAmount': 'Vui lòng nhập số tiền',
  'luckySpin.template.validate.cashAmountNegative': 'Số tiền không thể âm',
  'luckySpin.template.validate.flowMultiple': 'Vui lòng nhập bội số vòng cược',
  'luckySpin.template.validate.flowMultipleMin': 'Bội số vòng cược phải ≥ 1',
  'luckySpin.template.validate.pointAmount': 'Vui lòng nhập số điểm',
  'luckySpin.template.validate.pointAmountNegative': 'Số điểm không thể âm',
  'luckySpin.template.validate.pointAmountInteger': 'Điểm phải là số nguyên',
  'luckySpin.template.validate.prizeTitle': 'Vui lòng nhập tiêu đề giải thưởng',
  'luckySpin.template.validate.prizeTitleMax': 'Tối đa 100 ký tự',
  'luckySpin.template.validate.prizeLimit': 'Vui lòng nhập giới hạn',
  'luckySpin.template.validate.probability': 'Vui lòng nhập xác suất',
  'luckySpin.template.validate.probabilityRange': 'Phạm vi xác suất: 0-100',
  'luckySpin.template.validate.cooldownSeconds': 'Vui lòng nhập thời gian chờ',
  'luckySpin.template.validate.cooldownSecondsNegative': 'Thời gian chờ không thể âm',
  'luckySpin.template.validate.probabilitySum': 'Tổng xác suất phải là 100%',
  'luckySpin.template.validate.prizesCount': 'Vòng quay phải có đúng 8 giải thưởng',

  // Đa ngôn ngữ giải thực
  'luckySpin.template.physical.modalTitle': 'Cấu hình đa ngôn ngữ giải thưởng',
  'luckySpin.template.physical.prizeTitle': 'Tiêu đề giải thưởng',
  'luckySpin.template.physical.prizeImage': 'Hình ảnh giải thưởng',
  'luckySpin.template.physical.langConfigured': 'Đã cấu hình {count} ngôn ngữ',
  'luckySpin.template.physical.validate.prizeTitle': 'Vui lòng nhập tiêu đề giải thưởng',
  'luckySpin.template.physical.validate.prizeImage': 'Vui lòng tải lên hình ảnh giải thưởng',
  'luckySpin.template.physical.saveSuccess': 'Cấu hình đa ngôn ngữ đã được lưu',

  // Đa ngôn ngữ giải tiền mặt
  'luckySpin.template.cash.modalTitle': 'Cấu hình đa ngôn ngữ giải tiền mặt',
  'luckySpin.template.cash.prizeImage': 'Hình ảnh giải thưởng',
  'luckySpin.template.cash.prizeConfigButton': 'Cấu hình hình ảnh giải thưởng',
  'luckySpin.template.cash.langConfigured': 'Đã cấu hình {count} ngôn ngữ',
  'luckySpin.template.cash.validate.prizeImage': 'Vui lòng tải lên hình ảnh giải thưởng',
  'luckySpin.template.cash.saveSuccess': 'Cấu hình đa ngôn ngữ đã được lưu',

  // Đa ngôn ngữ giải điểm
  'luckySpin.template.points.modalTitle': 'Cấu hình đa ngôn ngữ giải điểm',
  'luckySpin.template.points.prizeImage': 'Hình ảnh giải thưởng',
  'luckySpin.template.points.prizeConfigButton': 'Cấu hình hình ảnh giải thưởng',
  'luckySpin.template.points.langConfigured': 'Đã cấu hình {count} ngôn ngữ',
  'luckySpin.template.points.validate.prizeImage': 'Vui lòng tải lên hình ảnh giải thưởng',
  'luckySpin.template.points.saveSuccess': 'Cấu hình đa ngôn ngữ đã được lưu',

  // Lịch sử phát vé
  'luckySpin.grantLog.title': 'Lịch sử phát vé tham gia',
  'luckySpin.grantLog.ticketName': 'Tên vé',
  'luckySpin.grantLog.grantSource': 'Kênh phát',
  'luckySpin.grantLog.grantType': 'Chi tiết phát',
  'luckySpin.grantLog.userName': 'Tài khoản',
  'luckySpin.grantLog.activityDataPkCode': 'Chọn hoạt động',
  'luckySpin.grantLog.selectActivity': 'Vui lòng chọn hoạt động',
  'luckySpin.grantLog.activityName': 'Tên vòng quay',
  'luckySpin.grantLog.status': 'Trạng thái vé',
  'luckySpin.grantLog.grantTime': 'Thời gian phát',
  'luckySpin.grantLog.type.label': 'Hình thức phát',
  'luckySpin.grantLog.type.placeholder': 'Vui lòng chọn hình thức phát',
  'luckySpin.grantLog.search': 'Tìm kiếm',
  'luckySpin.grantLog.reset': 'Đặt lại',
  'luckySpin.grantLog.export': 'Xuất',
  'luckySpin.grantLog.exporting': 'Đang xuất dữ liệu...',
  'luckySpin.grantLog.exportSuccess': 'Xuất thành công',
  'luckySpin.grantLog.exportFailed': 'Xuất thất bại',

  // Kênh phát
  'luckySpin.grantLog.source.vipReward': 'Phần thưởng VIP',
  'luckySpin.grantLog.source.batchGrant': 'Phát hàng loạt',
  'luckySpin.grantLog.source.systemReward': 'Phần thưởng hệ thống',
  'luckySpin.grantLog.source.manual': 'Phát thủ công',
  'luckySpin.grantLog.source.pointsMall': 'Cửa hàng điểm',
  'luckySpin.grantLog.source.spinAgain': 'Quay lại',
  'luckySpin.grantLog.source.pointExchange': 'Đổi điểm',
  'luckySpin.grantLog.source.actReward': 'Phần thưởng hoạt động',

  // Loại phát
  'luckySpin.grantLog.type.manual': 'Phát thủ công',
  'luckySpin.grantLog.type.vipUpgrade': 'Nâng cấp VIP',
  'luckySpin.grantLog.type.activityReward': 'Phần thưởng hoạt động',
  'luckySpin.grantLog.type.system': 'Hệ thống',

  // Trạng thái vé
  'luckySpin.grantLog.status.unused': 'Chưa sử dụng',
  'luckySpin.grantLog.status.used': 'Đã sử dụng',
  'luckySpin.grantLog.status.expired': 'Đã hết hạn',
  'luckySpin.grantLog.status.cancelled': 'Đã hủy',

  // Lịch sử quay
  'luckySpin.spinLog.title': 'Lịch sử quay thưởng',
  'luckySpin.spinLog.userName': 'Tài khoản',
  'luckySpin.spinLog.activityName': 'Tên vòng quay',
  'luckySpin.spinLog.ticketName': 'Tên vé',
  'luckySpin.spinLog.spinTime': 'Thời gian quay',
  'luckySpin.spinLog.prizeType': 'Loại giải',
  'luckySpin.spinLog.prizeContent': 'Nội dung giải',
  'luckySpin.spinLog.grantStatus': 'Trạng thái phát',
  'luckySpin.spinLog.grantTime': 'Thời gian phát',
  'luckySpin.spinLog.search': 'Tìm kiếm',
  'luckySpin.spinLog.reset': 'Đặt lại',
  'luckySpin.spinLog.export': 'Xuất',
  'luckySpin.spinLog.exporting': 'Đang xuất dữ liệu...',
  'luckySpin.spinLog.exportSuccess': 'Xuất thành công',
  'luckySpin.spinLog.exportFailed': 'Xuất thất bại',

  // Loại giải
  'luckySpin.spinLog.prize.cash': 'Tiền mặt',
  'luckySpin.spinLog.prize.points': 'Điểm',
  'luckySpin.spinLog.prize.physical': 'Thực phẩm',
  'luckySpin.spinLog.prize.again': 'Quay lại',
  'luckySpin.spinLog.prize.none': 'Không trúng',

  // Trạng thái phát
  'luckySpin.spinLog.grant.pending': 'Chờ xử lý',
  'luckySpin.spinLog.grant.success': 'Thành công',
  'luckySpin.spinLog.grant.failed': 'Thất bại',
};

